import React, { useMemo, useState } from "react";

import InitialDataListPage from "../components/InitialDataListPage";

const DocTypeMain = ({
  masterList = [],
  name,
  onPageInsert,
  onRowSelected,
}) => {
  const [statusFilter, setStatusFilter] = useState("Y");

  const filteredMasterList = useMemo(() => {
    if (!Array.isArray(masterList)) return [];
    return masterList.filter((m) => String(m?.DocType_Status ?? "Y") === String(statusFilter));
  }, [masterList, statusFilter]);
  const columns = useMemo(
    () => [
      {
        key: "index",
        header: "#",
        width: "8%",
        align: "center",
        render: (_item, _index, { startIndex, itemIndex }) =>
          startIndex + itemIndex + 1,
      },
      {
        key: "DocType_Name",
        header: "ประเภทเอกสาร",
        width: "64%",
        align: "start",
        render: (item) => item.DocType_Name || "-",
      },
      {
        key: "DocType_Status",
        header: "สถานะ",
        width: "16%",
        align: "center",
        render: (item) =>
          item.DocType_Status === "Y" ? "ใช้งาน" : "ไม่ใช้งาน",
      },
      {
        key: "actions",
        header: "แก้ไข",
        width: "12%",
        align: "center",
        isAction: true,
        render: (item, _index, { triggerRowSelected }) => (
          <button
            onClick={(event) => {
              event.stopPropagation();
              triggerRowSelected(item);
            }}
            className="btn btn-sm"
            title="แก้ไข"
            style={{
              width: "32px",
              height: "32px",
              borderRadius: "8px",
              border: "none",
              backgroundColor: "#fff3e0",
              color: "#EF6C00",
              transition: "all 0.2s ease",
            }}
            onMouseOver={(event) => {
              event.currentTarget.style.backgroundColor = "#EF6C00";
              event.currentTarget.style.color = "#fff";
            }}
            onMouseOut={(event) => {
              event.currentTarget.style.backgroundColor = "#fff3e0";
              event.currentTarget.style.color = "#EF6C00";
            }}
            type="button"
          >
            <i className="fas fa-edit" />
          </button>
        ),
      },
    ],
    []
  );

  const getSearchValues = useMemo(
    () => (item) => [
      item?.DocType_Name,
      item?.DocType_Status === "Y" ? "ใช้งาน" : "ไม่ใช้งาน",
    ],
    []
  );

  const customHeader = (
    <div className="d-flex align-items-center" style={{ width: '100%', gap: 16, flexWrap: 'nowrap' }}>
      <label className="mb-0" style={{ fontWeight: 700, fontSize: 13, marginRight: 8, minWidth: 150, whiteSpace: 'nowrap' }}>สถานะการใช้งาน</label>

      <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
        <label style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 0 }}>
          <input style={{ accentColor: '#E13F57', width: 16, height: 16 }} className="form-check-input" type="radio" name="docTypeStatusFilter" id="filterDocTypeActive" value="Y" checked={statusFilter === "Y"} onChange={() => setStatusFilter("Y")} />
          <span style={{ fontSize: 14 }}>ใช้งาน</span>
        </label>

        <label style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 0 }}>
          <input style={{ accentColor: '#E13F57', width: 16, height: 16 }} className="form-check-input" type="radio" name="docTypeStatusFilter" id="filterDocTypeInactive" value="N" checked={statusFilter === "N"} onChange={() => setStatusFilter("N")} />
          <span style={{ fontSize: 14 }}>ไม่ใช้งาน</span>
        </label>
      </div>
    </div>
  );

  return (
    <InitialDataListPage
      name={name}
      entityPath="/docType"
      data={filteredMasterList}
      onCreate={onPageInsert}
      onRowSelected={onRowSelected}
      columns={columns}
      getSearchValues={getSearchValues}
      searchPlaceholder={`ค้นหา${name || "ประเภทเอกสาร"}...`}
      fieldMappings={{ no: "DocType_Id" }}
      getRowId={(item) => item?.DocType_Id}
      customHeader={customHeader}
    />
  );
};

export default DocTypeMain;
